import { updateTicker } from '@/mocks/home';

export default function UpdateBar() {
  const items = [...updateTicker, ...updateTicker];

  return (
    <div className="w-full bg-primary-500 text-background-50">
      <div className="flex items-center h-9 overflow-hidden">
        <div className="hidden sm:flex items-center gap-1.5 h-full px-4 bg-primary-600 shrink-0">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill text-[11px]"></i>
          </span>
          <span className="text-[11px] font-medium tracking-[0.16em]">本期更新</span>
        </div>
        <div className="relative flex-1 h-full flex items-center overflow-hidden">
          <div className="flex animate-ticker whitespace-nowrap">
            {items.map((text, index) => (
              <span key={index} className="flex items-center">
                <span className="px-5 text-xs text-background-50/90">{text}</span>
                <span className="w-3 h-3 flex items-center justify-center text-background-50/50">
                  <i className="ri-circle-fill text-[6px]"></i>
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}